import dayjs from 'dayjs'

/**
 *
 * @param birthDateStr ex) '2022-03-14T09:42:43.852Z'
 * @returns ex) '2 years 3 months'
 */
function convertPetAge(birthDateStr: string): string {
  const date = dayjs(birthDateStr)
  const monthDiff = dayjs().diff(date, 'month')

  if (monthDiff <= 0) {
    return 'Less than 1 month'
  }

  if (monthDiff === 12) {
    return '1 year'
  }

  if (monthDiff >= 12) {
    const years = Math.floor(monthDiff / 12)
    const months = monthDiff % 12

    if (months) {
      return `${years} ${years > 1 ? 'years' : 'year'} ${months} ${months > 1 ? 'months' : 'month'}`
    }

    return `${years} ${years > 1 ? 'years' : 'year'}`
  }

  return `${monthDiff} ${monthDiff > 1 ? 'months' : 'month'}`
}

export default convertPetAge
